'use client';

import { c as _c } from "react/compiler-runtime";
import DesktopMap from '@images/renders/architecture_images/map/desktop/webp/1.webp';
import MobileMap from '@images/renders/architecture_images/map/mobile/webp/1.webp';
import scrollDescriptionIcon from '@images/renders/visual_images/tagMob.svg';
import D2 from '@images/svg/map/D2.svg';
import EkoRoadLine from '@images/svg/map/EkoRoadLine.svg';
import EkoRoadLineActive from '@images/svg/map/EkoRoadLineActive.svg';
import Mck from '@images/svg/map/Mck.svg';
import Park from '@images/svg/map/Park.svg';
import Park2 from '@images/svg/map/Park2.svg';
import Road from '@images/svg/map/Road.svg';
import School from '@images/svg/map/School.svg';
import { URLS } from '@lib/tools/helpers/constants';
import cn from 'classnames';
import NextImage from 'next/image';
import { useLayoutEffect, useRef, useState } from 'react';
import Svg from 'react-inlinesvg';
import BlurTooltip from '../../blur-tooltip/BlurTooltip';
import ParallaxMedia from '../../parallax-media/ParallaxMedia';
import BlurTooltipMap from './blue-tooltip-map/BlurTooltipMap';
import style from './InteractiveMapDesktop.module.scss';
const COMPASS_CDN = `${URLS.CDN_PLANS}/compass.svg`;
function InteractiveMapDesktop(t0) {
  const $ = _c(71);
  const {
    isMobile,
    children
  } = t0;
  const [tap, setTap] = useState(false);
  const mapContainer = useRef(null);
  const desktopBgRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsScrolling(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleScroll = t1;
  let t2;
  let t3;
  if ($[1] !== isMobile) {
    t2 = () => {
      if (isMobile) {
        return;
      }
      const box = mapContainer.current;
      if (!box) {
        return;
      }
      const scaleMap = () => {
        const h = box.offsetHeight;
        const vh = box.parentElement.offsetHeight;
        if (h > 0 && h < vh) {
          box.style.transform = `scale(${vh / h})`;
          box.style.transformOrigin = "top center";
        }
        if (desktopBgRef.current) {
          desktopBgRef.current.style.opacity = "1";
        }
      };
      scaleMap();
      window.addEventListener("resize", scaleMap);
      return () => {
        window.removeEventListener("resize", scaleMap);
        box.style.transform = "";
        box.style.transformOrigin = "";
      };
    };
    t3 = [isMobile];
    $[1] = isMobile;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const center = mapContainer.current.scrollWidth / 2 - mapContainer.current.clientWidth / 2;
      mapContainer.current.scrollTo(center + 30, mapContainer.current);
      setTimeout(() => {
        setIsScrolling(false);
      }, 200);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const scrollToCenter = t4;
  let t5;
  if ($[5] !== isMobile || $[6] !== isScrolling) {
    t5 = isMobile && !isScrolling && <BlurTooltip someStyles={style.scrollDescriptionIcon}><Svg src={scrollDescriptionIcon.src} /></BlurTooltip>;
    $[5] = isMobile;
    $[6] = isScrolling;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isMobile) {
    t6 = !isMobile ? {
      height: `${DesktopMap.height / DesktopMap.width * 100}vw`
    } : undefined;
    $[8] = isMobile;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Svg src={EkoRoadLine.src} id="ekoRoad" className={cn(style.ekoRoadLine__svg, false ? style.stage__hidden : style.stage__visible, style.cursorAuto)} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={style.ekoRoadLine}>{t7}<Svg src={EkoRoadLineActive.src} id="ekoRoad" className={cn(style.ekoRoadLine__svg, false ? style.stage__visible : style.stage__hidden, style.cursorAuto)} /></div>;
    t9 = <BlurTooltipMap svg={Park} someStyles={style.park} title={"\u041F\u0430\u0440\u043A \u041F\u043E\u043A\u0440\u043E\u0432\u0441\u043A\u043E\u0435-\u0421\u0442\u0440\u0435\u0448\u043D\u0435\u0432\u043E"} />;
    t10 = <BlurTooltipMap svg={Park2} someStyles={style.park2} title={"\u041F\u0430\u0440\u043A \u0412\u0441\u0435\u0445\u0441\u0432\u044F\u0442\u0441\u043A\u0430\u044F \u0440\u043E\u0449\u0430"} />;
    t11 = <BlurTooltipMap svg={Road} someStyles={style.road} title={"\u0412\u043E\u043B\u043E\u043A\u043E\u043B\u0430\u043C\u0441\u043A\u043E\u0435 \u0448\u043E\u0441\u0441\u0435"} />;
    t12 = <BlurTooltipMap svg={School} someStyles={style.school} title={"\u0414\u0435\u0442\u0441\u043A\u0438\u0439 \u0441\u0430\u0434 \u0438\xA0\u0448\u043A\u043E\u043B\u0430"} />;
    t13 = <BlurTooltipMap someStyles={style.d2} svg={D2} title={"\u0421\u0442\u0440\u0435\u0448\u043D\u0435\u0432\u043E"} />;
    t14 = <BlurTooltipMap svg={Mck} someStyles={style.mck} title={"\u0421\u0442\u0440\u0435\u0448\u043D\u0435\u0432\u043E"} />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
    $[16] = t8;
    $[17] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
    t14 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className={style.compass}><Svg src={COMPASS_CDN} id="ekoRoad" className={style.compass__icon} /></div>;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== isMobile) {
    t16 = !isMobile && <h1 className={style.textBlock}><span>Квартал </span><span>для красивой линии</span><span>жизни</span></h1>;
    $[19] = isMobile;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== children || $[22] !== t16) {
    t17 = <div className={style.introInner}>{children}{t16}</div>;
    $[21] = children;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className={cn(style.stage, style.stage__one)}>I очередь</div>;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  const t19 = tap ? style.stage__hidden : style.stage__visible;
  let t20;
  if ($[25] !== t19) {
    t20 = cn(style.stage, style.stage__two, t19);
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== isMobile || $[28] !== tap) {
    t21 = () => isMobile ? setTap(!tap) : null;
    $[27] = isMobile;
    $[28] = tap;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  let t23;
  if ($[30] !== isMobile) {
    t22 = () => !isMobile ? setTap(true) : null;
    t23 = () => !isMobile ? setTap(false) : null;
    $[30] = isMobile;
    $[31] = t22;
    $[32] = t23;
  } else {
    t22 = $[31];
    t23 = $[32];
  }
  let t24;
  if ($[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23) {
    t24 = <div className={t20} onClick={t21} onMouseEnter={t22} onMouseLeave={t23} role="button" tabIndex="0">II очередь</div>;
    $[33] = t20;
    $[34] = t21;
    $[35] = t22;
    $[36] = t23;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  const t25 = tap ? style.stage__visible : style.stage__hidden;
  let t26;
  if ($[38] !== t25) {
    t26 = cn(style.stage__buildings, t25);
    $[38] = t25;
    $[39] = t26;
  } else {
    t26 = $[39];
  }
  let t27;
  if ($[40] !== isMobile || $[41] !== tap) {
    t27 = () => isMobile ? setTap(!tap) : null;
    $[40] = isMobile;
    $[41] = tap;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  let t29;
  if ($[43] !== isMobile) {
    t28 = () => !isMobile ? setTap(true) : null;
    t29 = () => !isMobile ? setTap(false) : null;
    $[43] = isMobile;
    $[44] = t28;
    $[45] = t29;
  } else {
    t28 = $[44];
    t29 = $[45];
  }
  let t30;
  let t31;
  let t32;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className={cn(style.stage, style.stage__twoOne)}>корпус 2.1</div>;
    t31 = <div className={cn(style.stage, style.stage__twoTwo)}>корпус 2.2</div>;
    t32 = <div className={cn(style.stage, style.stage__twoThree)}>корпус 2.3</div>;
    $[46] = t30;
    $[47] = t31;
    $[48] = t32;
  } else {
    t30 = $[46];
    t31 = $[47];
    t32 = $[48];
  }
  let t33;
  if ($[49] !== t26 || $[50] !== t27 || $[51] !== t28 || $[52] !== t29) {
    t33 = <div className={t26} onClick={t27} onMouseEnter={t28} onMouseLeave={t29} role="button" tabIndex="0">{t30}{t31}{t32}</div>;
    $[49] = t26;
    $[50] = t27;
    $[51] = t28;
    $[52] = t29;
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  let t34;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className={cn(style.stage, style.stage__three)}>III очередь</div>;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  if ($[55] !== t24 || $[56] !== t33) {
    t35 = <div>{t18}{t24}{t33}{t34}</div>;
    $[55] = t24;
    $[56] = t33;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== isMobile) {
    t36 = !isMobile && <div ref={desktopBgRef}><ParallaxMedia src={DesktopMap} src375={MobileMap} name="bgr_1" className={style.bgStyle} imagePlug={DesktopMap} priority={true} /></div>;
    $[58] = isMobile;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  let t37;
  if ($[60] !== isMobile) {
    t37 = isMobile && <NextImage src={MobileMap} className={style.bgStyle} alt={"\u043A\u0430\u0440\u0442\u0430"} onLoad={scrollToCenter} />;
    $[60] = isMobile;
    $[61] = t37;
  } else {
    t37 = $[61];
  }
  let t38;
  if ($[62] !== t17 || $[63] !== t35 || $[64] !== t36 || $[65] !== t37 || $[66] !== t6) {
    t38 = <div className={style.mapBox} ref={mapContainer} onScroll={handleScroll} style={t6}>{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t17}{t35}{t36}{t37}</div>;
    $[62] = t17;
    $[63] = t35;
    $[64] = t36;
    $[65] = t37;
    $[66] = t6;
    $[67] = t38;
  } else {
    t38 = $[67];
  }
  let t39;
  if ($[68] !== t38 || $[69] !== t5) {
    t39 = <div className={style.mapBlock}>{t5}{t38}</div>;
    $[68] = t38;
    $[69] = t5;
    $[70] = t39;
  } else {
    t39 = $[70];
  }
  return t39;
}
export default InteractiveMapDesktop;